import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { AggregateService, GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems, PageEventArgs } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { MenuFuncionService, GastoService, ComunidadService, TenantService } from '../../../../src/app/shared/services';
import { Comunidad, GridPageSettings, MenuFuncionCodes, SearchComunidadRequest, SearchGastoRequest, Gasto, LocalStorageKeys, TenantFeatureFlags } from '../../../../src/app/shared/model';
import { ExportMediaTypeConstants } from '../../shared/model';

@Component({
  selector: 'app-miGastoLista',
  templateUrl: './miGastoLista.component.html',
  styleUrls: ['./miGastoLista.component.scss'],
  providers: [ AggregateService ]
})

export class MiGastoListaComponent implements OnInit {
  @ViewChild('grid')
  public grid: GridComponent;

  public data: DataManager;
  total: number = 0;
  searchForm: FormGroup;

  comunidadList: Comunidad[];

  isValidating: boolean = false;
  isSearching: boolean = false;
  isExporting: boolean = false;
  isComunidadSearching: boolean = false;
  isStatisticsSearching: boolean = false;

  tenantFeatureFlags: TenantFeatureFlags;

  canEdit: boolean = false;
  canView: boolean = false;

  public query: Query;
  public totales: any[];

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  constructor(
    private formBuilder: FormBuilder,
    private sharedFunctions: SharedFunctions,
    private router: Router,
    private route: ActivatedRoute,
    private menuService: MenuFuncionService,
    private service: GastoService,
    private comunidadService: ComunidadService,
    private tenantService: TenantService,
    private datePipe: DatePipe) {

  }

  ngOnInit(): void {
    this.menuService.checkMenu(MenuFuncionCodes.MI_GASTO_LIST).subscribe(data => {
      if (data != null && data.Success && data?.Result) {

        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          this.isValidating = false;
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;

            this.canView = true;
            this.loadView();
          }
        },
        (err: HttpErrorResponse) => {
          this.isValidating = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.isValidating = false;
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.canView = true;

    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };


    this.buildForm();

    this.setQueryParams();
    this.data = new DataManager({
      url: this.service.getMySearchUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.service.getAuthorizationHeader(),this.service.getTenantHeader()]
    });

    this.getSearchEstadisticas();
    this.getComunidades();
  }

  isProcessing() {
    return (this.isSearching || this.isExporting);
  }

  onGridActionFailure(event: any): void {
    this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
  }

  onActionBegin(args: PageEventArgs) {
    if (args.requestType === 'paging' && !this.isSearching)
    {
      this.searchForm.get('gridPage')?.setValue(args.currentPage);
      this.sharedFunctions.setReporteFiltros("app-miGastoLista", this.searchForm.getRawValue());
    }
  }

  clearDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
        if (this.searchForm.get(formFieldName) != null && this.searchForm.get(formFieldName)?.value)
            this.searchForm.get(formFieldName)?.setValue(null);
    }
  }

  getComunidades() {
    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isComunidadSearching = true;

    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadSearching = false;
      if (data != null)
        this.comunidadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  buildForm() {
    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    this.searchForm = this.formBuilder.group({
      'Detalle': [null],
      'FechaGastoDesde': [null],
      'FechaGastoHasta': [null],
      // 'Proveedor': [null],
      // 'ConsorcioId': [cId],
      'ComunidadId': [null],
      'UnidadFuncionalCodigo': [null],
      // 'TipoGastoId': [null],
      // 'ServicioGastoId': [null],
      // 'ClaseGasto': [null],
      'VerSoloActivos': [true],
      // 'VerSoloPendientesLiquidacion': [false],
      'gridPage': [1]
    });

    var filtros = this.sharedFunctions.getReporteFiltros("app-miGastoLista");

    if (filtros != null) {
      this.searchForm.patchValue(filtros);
      if (filtros.gridPage != null && filtros.gridPage > 0)
        this.pageSettings.currentPage = filtros.gridPage;
    }
  }

  onSearch() {
    this.searchForm.get('gridPage')?.setValue(1);
    this.sharedFunctions.setReporteFiltros("app-miGastoLista", this.searchForm.getRawValue());

    this.setQueryParams();
    this.grid.refresh();

    this.getSearchEstadisticas();
  }

  getSearchEstadisticas() {
    var search = new SearchGastoRequest(null, null, null, "", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null);
    search = Object.assign(search, this.searchForm.value);

    this.isStatisticsSearching = true;
    this.service.getMySearchEstadisticas(search).subscribe(data => {
      this.isStatisticsSearching = false;
      if (data.Success)
        this.totales = data.Result.Totales;
    },
    (err: HttpErrorResponse) => {
      this.isStatisticsSearching = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "Detalle");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Detalle;
    else
      this.query.addParams("Detalle",this.searchForm.value.Detalle);

    index = this.query.params.findIndex(obj => obj.key === "FechaGastoDesde");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaGastoDesde,"yyyy-MM-dd");
    else
      this.query.addParams("FechaGastoDesde",this.datePipe.transform(this.searchForm.value.FechaGastoDesde,"yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "FechaGastoHasta");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaGastoHasta,"yyyy-MM-dd");
    else
      this.query.addParams("FechaGastoHasta",this.datePipe.transform(this.searchForm.value.FechaGastoHasta,"yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "ComunidadId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ComunidadId;
    else
      this.query.addParams("ComunidadId",this.searchForm.value.ComunidadId);

    index = this.query.params.findIndex(obj => obj.key === "UnidadFuncionalCodigo");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.UnidadFuncionalCodigo;
    else
      this.query.addParams("UnidadFuncionalCodigo",this.searchForm.value.UnidadFuncionalCodigo);

    index = this.query.params.findIndex(obj => obj.key === "VerSoloActivos");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.VerSoloActivos.toString();
    else
      this.query.addParams("VerSoloActivos", this.searchForm.value.VerSoloActivos.toString());
  }

  edit(item: Gasto) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    this.router.navigate(['gasto-edit', item.Id]);
  }

  onExport() {
    var search = new SearchGastoRequest(null, null, null, "", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null);
    search = Object.assign(search, this.searchForm.value);

    this.isExporting = true;
    this.service.exportMySearch(search).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "Gastos_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }
}
